// Starts with a $ followed by exactly 6 alphanumeric characters
const registercodePattern = /^\$[A-Za-z0-9]{6}$/;

/**
 * registercode is valid, if it is empty or if it matches our validator
 * @param registercode
 */
export function isValidRegistercode(registercode: string): boolean {
  if (!registercode) {
    return true;
  }
  return registercodePattern.test(registercode);
}

